// src/components/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../firebaseConfig';
import { signInWithEmailAndPassword, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import Main from './Main';
import '../responsive.css';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async () => {
    setError('');
    console.log("Attempting login with email:", email);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log("✅ Authenticated user:", user.email, user.uid);

      const userDocRef = doc(db, "users", user.uid);
      const userDoc = await getDoc(userDocRef);

      if (userDoc.exists()) {
        const userData = userDoc.data();
        const role = (userData.role || '').toLowerCase();
        console.log("🔐 Retrieved role:", role);

        // 
        navigate('/projects');

      } else {
        console.error('🚫 No Firestore document found for user:', user.uid);
        setError('User role is not defined. Please contact support.');
      }

    } catch (error) {
      console.error('❌ Login Error:', error.code, error.message);
      setError(`Login failed: ${error.message}`);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("✅ Signed out successfully");
    } catch (error) {
      console.error("❌ Sign-out error:", error);
    }
  };

  return (
    <div>
      <Main />
      <div className="login-container">
        <input 
          type="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          placeholder="Email" 
        />
        <input 
          type="password" 
          value={password} 
          onChange={(e) => setPassword(e.target.value)} 
          placeholder="Password" 
        />
        {error && <div className="error-message">{error}</div>}
        <button onClick={handleLogin}>Login</button>
        <button onClick={handleLogout} style={{ marginTop: '10px' }}>Sign Out</button>
      </div>
    </div>
  );
}

export default Login;
